import type { CityConfig } from "../city-template/types";

export const wakeForestConfig: CityConfig = {
  city: "Wake Forest",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "wake-forest",
  route: "/cities/wake-forest",
  title: "Emergency Passport Wake Forest, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wake Forest, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wake County and the Research Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Wake Forest, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Wake Forest and Wake County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wake%20Forest%20North%20Carolina%20downtown%20at%20golden%20hour%20with%20historic%20Main%20Street%20and%20charming%20brick%20storefronts%2C%20tree-lined%20suburban%20boulevard%20with%20lush%20green%20oaks%2C%20warm%20sunset%20light%20over%20the%20Research%20Triangle%20northern%20suburbs%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20suburban%20southern%20elegance%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=wakeforest-hero-nc-001&orientation=landscape",
  heroImageAlt: "Wake Forest North Carolina downtown with historic Main Street at golden hour in Wake County",
  geoPosition: "35.9799;-78.5097",
  geoPlacename: "Wake Forest, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 340 miles from Wake Forest via I-85",
  },
  nearbyCitiesZips: [
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Rolesville", zips: "27571" },
    { name: "Youngsville", zips: "27596" },
    { name: "Franklinton", zips: "27525" },
    { name: "Louisburg", zips: "27549" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Raleigh", zips: "27601, 27602, 27603, 27604, 27605, 27606, 27607, 27608, 27609, 27610, 27612, 27613, 27614, 27615, 27616, 27617, 27623, 27695, 27697, 27698, 27699" },
    { name: "Durham", zips: "27701, 27702, 27703, 27704, 27705, 27706, 27707, 27708, 27709, 27710, 27711, 27712, 27713, 27715, 27717, 27722" },
    { name: "Cary", zips: "27511, 27512, 27513, 27518, 27519" },
    { name: "Chapel Hill", zips: "27514, 27515, 27516, 27517" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Henderson", zips: "27536, 27537" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Greensboro", zips: "27401, 27402, 27403, 27404, 27405, 27406, 27407, 27408, 27409, 27410, 27411, 27412, 27413, 27415, 27416, 27417, 27419, 27420, 27425, 27427, 27429, 27435, 27438, 27455, 27495, 27497, 27498, 27499" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wake County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Triangle Hub", desc: "Serving Wake Forest, Rolesville, and the northern Research Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Durham, NC", route: "/cities/durham" },
    { name: "Emergency passport help in Cary, NC", route: "/cities/cary" },
    { name: "Urgent passport services in Chapel Hill, NC", route: "/cities/chapel-hill" },
    { name: "Passport courier services in Rocky Mount, NC", route: "/cities/rocky-mount" },
    { name: "Same-day passport help in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Emergency passport help in Morrisville, NC", route: "/cities/morrisville" },
    { name: "Passport courier services in Garner, NC", route: "/cities/garner" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wake Forest remotely via secure courier. We do not have a walk-in office in Wake Forest — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and the northern Research Triangle.",
  fpcOfficeDistance: "Serving all of Wake County and the northern Research Triangle",
  serviceAreaIntro: "From downtown Wake Forest's historic Main Street to the Rolesville suburbs, from the Youngsville countryside to the Franklin County border — Fast Passport Center serves the entire Wake Forest region. We regularly help travelers from Raleigh, Durham, Cary, Chapel Hill, Knightdale, Zebulon, Wendell, Rocky Mount, and Henderson get their passports fast.",
  nearbyCitiesIntro: "We serve all Wake Forest neighborhoods and the surrounding Research Triangle area including Rolesville, Youngsville, Franklinton, Louisburg, Knightdale, Zebulon, Wendell, Raleigh, Durham, Cary, Chapel Hill, Rocky Mount, Henderson, and Wilson. If you are anywhere in Wake County or the northern Research Triangle, we have you covered.",
  howItWorksIntro: "Most Wake Forest travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Wake Forest travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Wake Forest and Wake County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wake Forest? Here are the most common ones we hear from Wake County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Wake Forest international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Dr. Patricia L.",
      location: "Wake Forest, NC",
      rating: 5,
      text: "Medical conference in Paris in 3 days. My passport was expired. Fast Passport Center had my renewal in 26 hours. The agent called me personally to confirm delivery. Exceptional service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark S.",
      location: "Rolesville, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in London. Got it in 28 hours. Fast Passport Center is a lifesaver for anyone in the northern Triangle. No need to drive to Atlanta at all.",
      service: "Emergency Passport",
    },
    {
      name: "Catherine W.",
      location: "Youngsville, NC",
      rating: 5,
      text: "First passport for my 12-year-old before a Disney cruise to the Bahamas. Fast Passport Center made the whole process smooth. Had her passport in 4 days. Highly recommend for Triangle families.",
      service: "Child Passport",
    },
    {
      name: "Brian K.",
      location: "Knightdale, NC",
      rating: 5,
      text: "Lost passport 5 days before a business trip to Singapore. Fast Passport Center had a replacement in 31 hours. The document review caught an issue with my photo before submission.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "wakeforest-1",
      name: "Wake Forest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "235 E Holding Ave",
      city: "Wake Forest",
      state: "NC",
      zip: "27587",
      phone: "(919) 554-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wake Forest facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "wakeforest-2",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 New Bern Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 755-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles south of Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Wake County. Full passport services available. Alternative for Wake Forest south side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wakeforest-3",
      name: "Rolesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 S Main St",
      city: "Rolesville",
      state: "NC",
      zip: "27571",
      phone: "(919) 556-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles north of Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Rolesville and northern Wake Forest residents. Less crowded than main Raleigh office.",
      icon: "ri-mail-line",
    },
    {
      id: "wakeforest-4",
      name: "Franklinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 S Main St",
      city: "Franklinton",
      state: "NC",
      zip: "27525",
      phone: "(919) 494-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Franklin County. Alternative for Wake Forest north side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wakeforest-5",
      name: "Durham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "323 E Chapel Hill St",
      city: "Durham",
      state: "NC",
      zip: "27701",
      phone: "(919) 683-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles west of Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Durham County. Alternative for Wake Forest west side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wakeforest-6",
      name: "Cary Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Academy St",
      city: "Cary",
      state: "NC",
      zip: "27511",
      phone: "(919) 467-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles southwest of Wake Forest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cary and western Wake County. Alternative for Wake Forest southwest residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Wake Forest photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wake Forest applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wake Forest travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Wake Forest." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wake Forest address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Wake Forest before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Wake Forest for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Wake Forest?", a: "Fast Passport Center offers fast passport renewal in Wake Forest in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Wake Forest?", a: "The nearest regional passport agency to Wake Forest is the Atlanta Passport Agency, approximately 340 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Wake Forest without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Wake Forest?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5+ hours from Wake Forest — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County residents." },
    { q: "Do you serve the entire Research Triangle area?", a: "Absolutely. Fast Passport Center serves the entire Research Triangle area including Wake Forest, Raleigh, Durham, Cary, Chapel Hill, Knightdale, Zebulon, Wendell, and surrounding communities. Our courier service works seamlessly from any address in Wake County and the Triangle." },
    { q: "Can I expedite a child passport in Wake Forest?", a: "Yes. Fast Passport Center expedites child passports in Wake Forest for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Wake Forest with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Wake Forest", address: "11750 Retail Dr, Wake Forest, NC 27587", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wake Forest", address: "10000 Durant Rd, Raleigh, NC 27614", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Wake Forest", address: "1725 Heritage Centre Dr, Wake Forest, NC 27587", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Raleigh", address: "6200 Falls of Neuse Rd, Raleigh, NC 27609", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Raleigh", address: "Multiple locations", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Raleigh", address: "Multiple locations", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Durham", address: "2601 Hillsborough Rd, Durham, NC 27705", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Cary", address: "1197 Kildaire Farm Rd, Cary, NC 27511", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Wake Forest",
      address: "2116 S Main St, Wake Forest, NC 27587",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh",
      address: "4121 New Bern Ave, Raleigh, NC 27610",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Wake County central office. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Durham",
      address: "1821 S Miami Blvd, Durham, NC 27703",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Durham County office. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Louisburg",
      address: "110 S Main St, Louisburg, NC 27549",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Franklin County office. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "20 miles southwest of Wake Forest",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for Wake Forest travelers — only 20 minutes away.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles west of Wake Forest",
      address: "1000 A Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Regional airport with flights to major U.S. hubs. Alternative for western Wake County residents.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "160 miles southwest of Wake Forest",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Alternative for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
};